export default __webpack_public_path__ + "static/media/ether_task.fcb7497a.svg";